<div class="db-plan-label-booster"
     [ngClass]="{'canceled': isExpired, 'full-width': (!userSubscription?.plan?.recurring &&
     !userSubscription?.isExpired &&
     !userSubscription?.trialBoosterClient) || userSubscription?.type === UserSubscriptionType.REGISTERED, 'db-plan-label-trial': (userSubscription?.plan.type === UserSubscriptionType.FREE && userSubscription?.trialBoosterClient)}">
  <div class="db-plan-label-booster__wrap">

    <div class="db-plan-label-booster__header" *ngIf="userSubscription?.boosterProClient">
      <div class="db-plan-label-booster__wrap-title b ">
        Booster {{userSubscription?.plan?.title}}</div>
      <div *ngIf="!globalIsExpired && !userSubscription?.recharge && userSubscription?.status !== userSubscriptionStatus.canceled">
        <button [routerLink]="['/upgrade-plan']" *ngIf="userSubscription?.boosterCategory !== 'agency'"
                class="ds-btn-small ds-btn-green rectangle"><span>Upgrade</span></button>
      </div>
    </div>

    <div class="db-plan-label-booster__header" *ngIf="userSubscription?.trialBoosterClient">
      <div class="db-plan-label-booster__wrap-title c">
        Booster Free
      </div>
      <div *ngIf="!globalIsExpired && !userSubscription?.recharge && userSubscription?.status !== userSubscriptionStatus.canceled">
        <button [routerLink]="['/upgrade-plan']"
                class="ds-btn-small ds-btn-green rectangle"><span>Upgrade</span></button>
      </div>
    </div>


    <div class="db-plan-label-booster__wrap-body">

      <!------------------- starter with booster -------------->
      <div>
        <div class="db-plan-label-booster__wrap-body-title-desc"
             *ngIf="userSubscription?.trialBoosterClient">
          <span class="db-small">Homepage + 5 pages</span>
        </div>

        <div class="db-plan-label-booster__wrap-body-feature db-plan-label-booster__wrap-body-feature-title mb10 mt20"
             *ngIf="userSubscription?.trialBoosterClient">
          <span class="db-small">Full frontend optimization</span>
        </div>


        <ng-container *ngFor="let feature of planFeatures">
          <div class="db-plan-label-booster__wrap-body-feature"
               *ngIf="userSubscription?.trialBoosterClient">
            <i class="db-icon db-icon-circle-sm"></i>
            <span class="db-feature">{{feature}}</span>
          </div>
        </ng-container>

      </div>
      <!------------------- end starter with trial -------------->

      <!------------------- booster pro start -------------->
      <div *ngIf="userSubscription?.boosterProClient">
        <div class="db-plan-label-booster__wrap-body-title-desc">
          <span
            class="db-small" [innerHTML]="('website' | wordsByCount : userSubscription?.plan?.totalDomainCount )"></span>
        </div>

        <div class="db-plan-label-booster__wrap-body-ai">

          <div>
            <div
              class="db-plan-label-booster__wrap-body-feature db-plan-label-booster__wrap-body-feature-title mb10 mt20">
              <span class="db-small">Full frontend optimization</span>
            </div>

            <ng-container *ngFor="let feature of planFeatures.slice(0,4)">
              <div class="db-plan-label-booster__wrap-body-feature booster-pro">
                <i class="db-icon db-icon-circle-sm"></i>
                <span class="db-feature" [innerHTML]="feature"></span>
              </div>
            </ng-container>
          </div>

          <div>
            <div
              class="db-plan-label-booster__wrap-body-feature db-plan-label-booster__wrap-body-feature-title mb10 mt20">
              <span class="db-small">Cloudflare Enterprise CDN</span>
            </div>

            <div class="db-plan-label-booster__wrap-body-feature">
              <i class="db-icon db-icon-circle-sm"></i>
              <span class="db-feature">{{('website' | wordsByCount : userSubscription?.plan?.cdnCountValue)}}</span>
            </div>

            <div class="db-plan-label-booster__wrap-body-feature">
              <i class="db-icon db-icon-circle-sm"></i>
              <span class="db-feature"
                    [innerHTML]="((userSubscription?.plan?.cdnBandwidthValue + (userSubscription?.plan?.additionalCDNCount ? (userSubscription?.plan?.cdnAdditionalBandwidthValue * userSubscription?.plan?.additionalCDNCount) : 0)) | size: {unit: 'MB'}) + ' Bandwidth'"></span>
            </div>

            <ng-container *ngFor="let feature of planFeatures.slice(4,7)">
              <div class="db-plan-label-booster__wrap-body-feature">
                <i class="db-icon db-icon-circle-sm"></i>
                <span class="db-feature" [innerHTML]="feature"></span>
              </div>
            </ng-container>

          </div>
        </div>

        <div class="db-plan-label-booster__wrap-body-add-ons mt20" *ngIf="userSubscription?.plan?.additionalDomainCount ||userSubscription?.plan?.additionalCDNCount ">
          <p>Add-ons</p>
        </div>

        <div class="db-plan-label-booster__wrap-body-ai">

          <div *ngIf="userSubscription?.plan?.additionalCDNCount">
            <div
              class="db-plan-label-booster__wrap-body-feature db-plan-label-booster__wrap-body-feature-title mb10 mt20">
              <span class="db-small">Cloudflare CDN add-on: {{userSubscription?.plan?.additionalCDNCount}} </span>
            </div>
            <div class="db-plan-label-booster__wrap-body-feature">
              <i class="db-icon db-icon-circle-sm"></i>
              <span class="db-feature" [innerHTML]="((userSubscription?.plan?.cdnAdditionalBandwidthValue * userSubscription?.plan?.additionalCDNCount) | size: {unit: 'MB'}) + ' CDN Bandwidth'"></span>
            </div>
          </div>

          <div *ngIf="userSubscription?.plan?.additionalDomainCount">
            <div
              class="db-plan-label-booster__wrap-body-feature db-plan-label-booster__wrap-body-feature-title mb10 mt20">
              <span class="db-small">Hosting add-on: {{userSubscription?.plan?.additionalDomainCount}}</span>
            </div>
            <div class="db-plan-label-booster__wrap-body-feature">
              <i class="db-icon db-icon-circle-sm"></i>
              <span class="db-feature" [innerHTML]="((userSubscription?.plan?.services?.hosting?.hosting_additional_visits?.parameter_value) * userSubscription?.plan?.additionalDomainCount | count) + ' monthly visitors'"></span>
            </div>
            <div class="db-plan-label-booster__wrap-body-feature">
              <i class="db-icon db-icon-circle-sm"></i>
              <span class="db-feature" [innerHTML]="((userSubscription?.plan?.services?.hosting?.hosting_additional_storage?.parameter_value * 1024 * 1024 * userSubscription?.plan?.additionalDomainCount) | size) + ' SSD storage'"></span>
            </div>
          </div>

        </div>
        <!------------------- booster pro end -------------->

      </div>
    </div>
  </div>
</div>
